import { supportsPassiveEvents } from "./supportsPassiveEvents";

describe("Passive Event Support Detection", () => {
    it("returns false if passive Events are not supported", () => {
        expect(supportsPassiveEvents).toEqual(false);
    });
});
